module.exports = __webpack_public_path__ + "static/img/lv1.4c1c2ba4.png";